/** The plus / minus glyph used by the page's expandable panels. */
export const ExpandToggleSign = ({ isOpen, color = "#8D8D8D", size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="1" y1="7" x2="13" y2="7" stroke={color} strokeWidth="1.2" />
    {!isOpen && (
      <line x1="7" y1="1" x2="7" y2="13" stroke={color} strokeWidth="1.2" />
    )}
  </svg>
);
